module.exports = __webpack_public_path__ + "img/lbg-logo.1d2272e0.svg";